
import Ficha from "./views/ficha";
import Tematica from "./views/tematicas";
import Indicador from "./views/indicadores";
const routes = [
    {
        path: `${process.env.PUBLIC_URL}/tematica`,
        component: Tematica
    },
    {
        path: `${process.env.PUBLIC_URL}/indicador`,
        component: Indicador
    },
    {
        path: `${process.env.PUBLIC_URL}/ficha`,
        component: Ficha
    },
    {
        path: `${process.env.PUBLIC_URL}/*`,
        component: Tematica
    }
];
export default routes;
